var _path, _rect, _rect2, _rect3, _circle, _path2, _path3, _path4, _path5, _circle2, _circle3, _path6, _circle4, _circle5, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSection1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 380,
    viewBox: "0 0 380 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248 336V336C248 334.142 248 333.213 247.877 332.436C247.199 328.157 243.843 324.801 239.564 324.123C238.787 324 237.858 324 236 324H144C142.142 324 141.213 324 140.436 324.123C136.157 324.801 132.801 328.157 132.123 332.436C132 333.213 132 334.142 132 336V336H248ZM248 336H288H92",
    stroke: "black",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 296,
    width: 52,
    height: 28,
    stroke: "black",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 130,
    width: 244,
    height: 166,
    rx: 10,
    stroke: "black",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 138,
    width: 228,
    height: 150,
    rx: 4,
    stroke: "black",
    strokeDasharray: "3 3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 173,
    r: 81,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173 255L164 264L173 273",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M187 273L193 255",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M207 255L216 264L207 273",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M223 237.009C246.164 225.042 262 200.871 262 173C262 133.235 229.765 101 190 101C150.235 101 118 133.235 118 173C118 200.871 133.836 225.042 157 237.009",
    stroke: "black",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 173,
    r: 65,
    fill: "#EAF1FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 173,
    r: 45,
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M203 163.37V163.37C203 156.805 197.678 151.484 191.114 151.484H190M177 182.63V182.63C177 189.195 182.322 194.516 188.886 194.516H190M190 151.484H187.154C181.546 151.484 177 156.03 177 161.638V161.638C177 166.179 180.015 170.168 184.384 171.407L195.616 174.593C199.985 175.832 203 179.821 203 184.362V184.362C203 189.97 198.454 194.516 192.846 194.516H190M190 151.484V144M190 151.484V194.516M190 194.516V202",
    stroke: "white",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 85,
    r: 5,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 331,
    cy: 57,
    r: 5,
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54 93H151.448L162.5 106",
    stroke: "black",
    strokeDasharray: "3 3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M326 57H231.552L210 103",
    stroke: "black",
    strokeDasharray: "3 3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24 80.8804L42.5 75L61 80.8804V87.6374C61 94.0199 61 97.2112 60.1075 100.098C59.3174 102.653 58.0229 105.024 56.3006 107.07C54.3548 109.381 51.6702 111.106 46.3009 114.557L42.5 117L38.6991 114.557C33.3298 111.106 30.6452 109.381 28.6994 107.07C26.977 105.024 25.6826 102.653 24.8925 100.098C24 97.2112 24 94.0199 24 87.6374V80.8804Z",
    fill: "#304FF2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36 94.5L40.906 100L50 89",
    stroke: "white",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M346 44L356 56L336 80L316 56L326 44H332.471L339.529 44L346 44Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M356 56L346 44L339.529 44M356 56L336 80M356 56H344.235M336 80L316 56M336 80L327.765 56M336 80L344.235 56M316 56L326 44H332.471M316 56L327.765 56M327.765 56H344.235M327.765 56L332.471 44M344.235 56L339.529 44M339.529 44L332.471 44",
    stroke: "black",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37 119V147",
    stroke: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47 119V135",
    stroke: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M341 85L341 113",
    stroke: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M331 85L331 101",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection1);
export default __webpack_public_path__ + "static/media/section1.fdd671237e7596c9003f653520535e38.svg";
export { ForwardRef as ReactComponent };